import React from 'react';
import { Tooltip, OverlayTrigger } from '@themesberg/react-bootstrap';
import { returnCustomerAddressString } from '../table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faRobot } from '@fortawesome/free-solid-svg-icons';
import { returnProductInfo, viewProductInfo } from './tableUtils';
import ActionButton from '../../pages/oms/interBranchTransfers/components/ActionButton';
import { returnUserReadableDate } from '../datetime';
import { schemeTypeMap } from './constantsAndUtils';

export const schemeTableRedesignColumns = ({
  handleMoreProductsClick,
  options,
  handleSelectedRowUpdate,
}) => {
  const renderToolTip = (props, row) => (
    <Tooltip id="button-tooltip" {...props}>
      Generated By Email.
      {row?.attachments?.[0]?.url && (
        <>
          <br />
          Click to Download.
        </>
      )}
    </Tooltip>
  );
  const columns = [
    // {
    //   dataField: 'objectId',
    //   text: 'Select',
    //   // formatter: (cell, row) => {
    //   //   return getTableRowCheckBox(onRowSelect, cell, row?.isSelected, false);
    //   // },
    // },
    {
      dataField: 'action',
      text: 'action',
      formatter: (cell, row) => {
        let currentOptions = options;
        switch (row.status) {
          case 'completed': {
            const toRemove = new Set([
              'Pre-Closure',
              'Complete',
              'Cancel',
              'Edit',
            ]);
            currentOptions = options.filter((item) => !toRemove.has(item));
            break;
          }
          case 'ongoing': {
            const toRemove = new Set(['Close']);
            currentOptions = options.filter((item) => !toRemove.has(item));
            break;
          }
          default:
            break;
        }
        return (
          <ActionButton
            options={currentOptions}
            onActionClick={(option) => handleSelectedRowUpdate(option, row)}
          />
        );
      },
    },
    {
      dataField: 'createdAt',
      text: 'Creation Date',
      formatter: (cell, row) => {
        return (
          <div className="d-block fw-bold">{returnUserReadableDate(cell)}</div>
        );
      },
    },
    {
      dataField: 'actionLog',
      text: 'Created By',
      formatter: (cell, row) => {
        return <div className="d-block fw-bold">{cell[0]?.user}</div>;
      },
    },
    {
      dataField: 'schemeCircularNo',
      text: 'SCHEME CIRCULAR',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            {row.schemeCircularNo && (
              <div className="d-block fw-bold">
                {returnCustomerAddressString(
                  `No: ${cell}`,
                  null,
                  200,
                  30,
                  'top'
                )}
              </div>
            )}
            <div className="d-block fw-bold">{`Date: ${returnUserReadableDate(
              row.schemeCircularDate
            )}`}</div>
            {row.isAutoGenerated && (
              <div>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={(props) => renderToolTip(props, row)}
                >
                  <div className="fs-4">
                    <FontAwesomeIcon
                      icon={faRobot}
                      onClick={() => {
                        if (row?.attachments?.[0]?.url) {
                          window.open(row?.attachments?.[0]?.url, '_blank');
                        }
                      }}
                    />
                  </div>
                </OverlayTrigger>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: 'company',
      text: 'BRAND',
    },
    {
      dataField: 'productCategory',
      text: 'CATEGORY',
      formatter: (cell, row) => {
        return returnProductInfo(cell, 'Categories');
      },
    },
    {
      dataField: 'products',
      text: 'PRODUCTS',
      formatter: (cell, row) => {
        return viewProductInfo({ cell, handleMoreProductsClick, row });
      },
    },
    {
      dataField: 'validFrom',
      text: 'DATE',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <div className="d-block fw-bold">
              {returnUserReadableDate(row.validFrom)}
            </div>
            <div className="d-block fw-bold">
              {returnUserReadableDate(row.validTill)}
            </div>
          </div>
        );
      },
    },
    {
      dataField: 'type',
      text: 'Scheme Type',
      formatter: (cell, row) => {
        return (
          <>
            <div>{cell}</div>
            {row?.sellIntype && <div>{row?.sellIntype}</div>}
          </>
        );
      },
    },
    {
      dataField: 'status',
      text: 'Status',
      formatter: (cell, row) => {
        return (
          <div className="d-flex flex-column gap-2">
            <SchemeBadge text={cell} />
            {row.actionType && (
              <>
                <FontAwesomeIcon
                  icon={faArrowDown}
                  style={{ right: '30px', position: 'relative' }}
                />
                <SchemeBadge text={row.actionType} />
              </>
            )}
          </div>
        );
      },
    },
  ];

  return columns;
};

export const SchemeBadge = ({ text }) => {
  const bgColor = {
    draft: '#F0F0F0',
    negotiation: '#FDEDD9',
    ongoing: '#E2F7FF',
    completed: '#D4F7E8',
    closed: '#FFEBEC',
    requestCancel: '#FF4136',
    requestComplete: '#D4F7E8',
    cancelled: '#FF4136',
    created: '#F2E6FF',
    edited: '#ECF9FD',
    active: '#D4F7E8',
    inactive: '#FDDDDD',
  };

  const color = {
    draft: '#444444',
    negotiation: '#F4921B',
    ongoing: '#00A3E0',
    completed: '#21A871',
    closed: '#E91E23',
    requestCancel: '#FFFFFF',
    requestComplete: '#21A871',
    cancelled: '#FFFFFF',
    created: '#6600C4',
    edited: '#0948B3',
    active: '#21A871',
    inactive: '#E91E23',
  };
  return (
    <div
      style={{
        backgroundColor: bgColor[text],
        color: color[text],
        fontWeight: '500',
        padding: 2,
        width: '126px',
        height: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {text?.toUpperCase()}
    </div>
  );
};

export const ViewProductsTable = (data) => {
  const columns = [
    {
      dataField: 'productName',
      text: 'Product Name',
    },
    {
      dataField: 'vanNo',
      text: 'Van No',
      formatter: (cell, row) => {
        if (Array.isArray(cell)) {
          return (
            <>
              {cell.map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </>
          );
        }
        return <>{cell}</>;
      },
    },
  ];
  if (data?.type?.[0] !== schemeTypeMap.foc) {
    columns.push(
      ...[
        {
          dataField: 'valuationType',
          text: 'Valuation Type',
        },
        {
          dataField: 'payout',
          text: 'Payout',
        },
      ]
    );
  } else {
    columns.push(
      ...[
        {
          dataField: 'mainProductQuantity',
          text: 'Quantity',
        },
        {
          dataField: 'freebieVan',
          text: 'Freebie Van',
          formatter: (cell, row) => {
            return (
              <>
                {cell?.map((item) => (
                  <div>{item}</div>
                ))}
              </>
            );
          },
        },
        {
          dataField: 'freebieQuantity',
          text: 'FreebieQuantity',
        },
        {
          dataField: 'slabs',
          text: 'Slab',
          formatter: (cell, row) => {
            return (
              <>{cell && Object.keys(cell)?.map((item) => <div>{item}</div>)}</>
            );
          },
        },
        {
          dataField: 'slabs',
          text: 'Slab Quantity',
          formatter: (cell, row) => {
            return (
              <>
                {cell && Object.values(cell)?.map((item) => <div>{item}</div>)}
              </>
            );
          },
        },
        {
          dataField: 'vanNoCapping',
          text: 'VanNo Capping',
        },
        {
          dataField: 'freebieVanCapping',
          text: 'Freebie Van Capping',
        },
      ]
    );
  }
  if (data.type?.[0] === 'Sell-out' && data.products?.[0]?.cappingType) {
    columns.push(
      ...[
        {
          dataField: 'cappingType',
          text: 'Capping Type',
        },
        {
          dataField: 'cappingQuantity',
          text: 'Capping Quantity',
        },
      ]
    );
  }
  if (data.type?.[0] === schemeTypeMap.foc) {
    if (data.focType?.[0] === 'Many-One' || data.focType?.[0] === 'Many-Many') {
      return [
        {
          dataField: 'vanNo',
          text: 'Applicable Model',
          formatter: (cell) => {
            return (
              <>
                {cell?.map((item) => (
                  <div>{item}</div>
                ))}
              </>
            );
          },
        },
        {
          dataField: 'focModel',
          text: 'Foc Model',
          formatter: (cell) => {
            console.log(cell);
            return (
              <>
                {cell?.map((item) => (
                  <div>{item}</div>
                ))}
              </>
            );
          },
        },
        {
          dataField: 'quantity',
          text: 'Incremental Quantity',
        },
        {
          dataField: 'focUnit',
          text: 'Foc Unit',
        },
        {
          dataField: 'slabs',
          text: 'Slab(Lower Limit)',
          formatter: (cell) => {
            return (
              <>
                {cell &&
                  Object.values(cell)?.map((item) => (
                    <div>{item.lowerLimit}</div>
                  ))}
              </>
            );
          },
        },
        {
          dataField: 'slabs',
          text: 'Slab(Upper Limit)',
          formatter: (cell) => {
            return (
              <>
                {cell &&
                  Object.values(cell)?.map((item) => (
                    <div>{item.higherLimit}</div>
                  ))}
              </>
            );
          },
        },
        {
          dataField: 'slabs',
          text: 'Slab Quantity',
          formatter: (cell) => {
            return (
              <>
                {cell &&
                  Object.values(cell)?.map((item) => <div>{item.focUnit}</div>)}
              </>
            );
          },
        },
        {
          dataField: 'applicableModelCapping',
          text: 'Applicable Mode Capping',
        },
        {
          dataField: 'focUnitCapping',
          text: 'Foc Unit Capping',
        },
      ];
    }
  }
  return columns;
};

export const schemesUsersListColumns = () => {};
